export default "__VITE_ASSET__5adb56f4__"